'use client';
import { useRef } from 'react';

export const useFn = (fn?: (...args: any) => any) => {
  const fnRef = useRef(fn);
  if (fnRef.current! == fn) {
    fnRef.current = fn;
  }
  return fnRef.current;
};
